export default "__VITE_ASSET__C2L8hqBG__"